module.exports = __webpack_public_path__ + "static/Signup2-3e2e0bb4d40b8b94f69d14a14da0d1cd.png";